/**
 * @file constants.ts
 * @description 聊天系统常量：接口地址、错误与状态枚举、需要展示的状态列表、溯源类型。
 */

/** 配置更新分隔符文本（系统消息显示用） */
export const SEPARATOR_TEXT = '配置已更新'

/** 角色设定为空的错误提示（发送前校验） */
export const ROLE_EMPTY_ERROR = '角色设定不能为空'

/**
 * 会话接口地址（SSE）
 * @constant
 */
export const CHAT_URL = '/api/v1/chat_agent/completions'

/**
 * Agent状态枚举
 *
 * 定义了聊天Agent在运行过程中的各种状态，用于前端状态管理和UI展示
 * 包括LLM处理、工具调用、检索、错误等状态
 */
export enum AgentStatus {
  llm_start = 1, // LLM开始处理
  chat_model_start = 2, // 聊天模型开始
  llm_new_token = 3, // LLM生成新token
  llm_end = 4, // LLM处理结束
  llm_error = 5, // LLM处理错误
  chain_start = 6, // 链式处理开始
  chain_end = 7, // 链式处理结束
  chain_error = 8, // 链式处理错误
  tool_start = 9, // 工具调用开始
  tool_end = 10, // 工具调用结束
  tool_error = 11, // 工具调用错误
  text = 12, // 文本处理
  retry = 13, // 重试
  retriever_start = 14, // 检索开始
  retriever_end = 15, // 检索结束
  retriever_error = 16, // 检索错误
  agent_action = 17, // Agent执行动作
  agent_finish = 18, // Agent完成
  think = 19, // 思考状态
  error = -1, // 通用错误
  // ---自定义状态---
  content_illegal = 30 // 内容违法
}

/**
 * 需要展示给用户的Assistant状态列表
 *
 * 定义了在聊天界面中需要向用户展示的Agent状态，
 * 这些状态会影响UI的显示和用户交互
 */
export const ASSISTANT_STATUS = [
  AgentStatus.llm_start,
  AgentStatus.chat_model_start,
  AgentStatus.llm_new_token,
  AgentStatus.llm_end,
  AgentStatus.llm_error,
  AgentStatus.chain_start,
  AgentStatus.chain_end,
  AgentStatus.chain_error,
  AgentStatus.tool_start,
  AgentStatus.tool_end,
  AgentStatus.tool_error,
  // AgentStatus.text,
  // AgentStatus.retry,
  AgentStatus.retriever_start,
  AgentStatus.retriever_end,
  AgentStatus.retriever_error,
  AgentStatus.agent_action,
  AgentStatus.agent_finish,
  AgentStatus.error,
  AgentStatus.think,
  // ---非法状态---
  AgentStatus.content_illegal
]

/**
 * 会话溯源类型：区分工具/知识库/MCP 来源
 */
export const CITATION_TYPE = {
  plugin: 'plugin', // 插件来源
  knowledge: 'knowledge', // 知识库来源
  mcp: 'mcp' // MCP来源
}
